/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Decks_No_DeckInputs */



/**
* | output |
* | --- |
* | "No deck" |
*
* @param {Decks_No_DeckInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const decks_no_deck = /** @type {((inputs?: Decks_No_DeckInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Decks_No_DeckInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pas de deck")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sin deck")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Sem deck")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun deck")
	return /** @type {LocalizedString} */ ("No deck")
});